import React from 'react'
import { observer } from 'mobx-react'
import { useTranslation } from 'react-i18next'
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'
import Box from '@mui/system/Box'
import Checkbox from '@mui/material/Checkbox'
import FormControl from '@mui/material/FormControl'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'

import PartnerTagIcon from './PartnerTagIcon'
import { useQuery } from '../models'

const MaybePartnerTagsField = observer(() => {
  const { store } = useQuery()
  const filteredPartnerTags = store.searchStore.filteredPartnerTagsList
  const { t } = useTranslation()
  const theme = useTheme()
  const mobile = useMediaQuery(theme.breakpoints.down('md'))

  const defaultPartnerTagOption = (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <PartnerTagIcon />
      {t(store.partner?.findAProviderConfig?.partnerTagLabel)}
    </Box>
  )

  const renderValue = value => {
    if (value.length === 0) {
      return defaultPartnerTagOption
    }

    return (
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <PartnerTagIcon />
        {value.length === 1
          ? value[0]
          : `${value.length} ${t(
              store.partner?.findAProviderConfig?.partnerTagLabel
            )}`}
      </Box>
    )
  }

  if (store.searchStore.partnerTagsFilterEnabled) {
    return (
      <FormControl>
        <Select
          id="partner-tags-filter"
          multiple
          displayEmpty
          disableUnderline
          variant="standard"
          value={filteredPartnerTags}
          renderValue={renderValue}
          onChange={event =>
            store.searchStore.setFilteredPartnerTags(event.target.value)
          }
          inputProps={{ 'aria-label': 'Partner Tag Filter' }}
          MenuProps={{
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
            transformOrigin: {
              vertical: 'top',
              horizontal: 'left',
            },
            PaperProps: {
              sx: {
                borderRadius: '8px',
              },
            },
            sx: {
              marginBlock: '0.5rem',
            },
          }}
          sx={{
            fontSize: '0.9rem',
            fontWeight: 500,
            [`& .MuiSelect-select`]: {
              pt: '6.5px',
              pb: '5px',
              pl: '8px',
              color: 'secondary.main',
              background: '#FFF',
              borderRadius: '8px',
              border: mobile ? 1 : 0,
              boxShadow: mobile ? 0 : 3,
              '&:focus': {
                borderRadius: 2,
                background: '#FFF',
              },
            },
            [`& .MuiSelect-icon`]: {
              color: 'secondary.main',
            },
          }}
        >
          <MenuItem value="" disabled>
            {defaultPartnerTagOption}
          </MenuItem>
          {store.partner?.partnerTags?.map(partnerTag => (
            <MenuItem key={partnerTag.id} value={partnerTag.name}>
              <Checkbox
                checked={filteredPartnerTags.indexOf(partnerTag.name) > -1}
              />
              {partnerTag.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    )
  }
  return null
})

MaybePartnerTagsField.displayName = 'MaybePartnerTagsField'
export default MaybePartnerTagsField
